<template>
  <div>
    <b-modal ref="modalUnsavedChanges"
             :title="$t('Webportal.Dialog.UnsavedChanges.Title')"
             :ok-title="$t('Webportal.Dialog.UnsavedChanges.Ok')"
             :cancel-title="$t('Webportal.Dialog.UnsavedChanges.Cancel')"
             no-close-on-esc
             no-close-on-backdrop
             hide-header-close>
      {{ $t('Webportal.Dialog.UnsavedChanges.Text') }}
    </b-modal>

    <div class="animated fadeIn">
      <div class="container my-3">
          <b-nav tabs>
            <b-nav-item to="/user/profile"><font-awesome-icon :icon="['far', 'user-cog']" fixed-width /> {{ $t('Webportal.Profile') }}</b-nav-item>
            <b-nav-item to="/user/notificationsettings" v-if="localUserProfile.Permissions.includes('NotificationSettings')"><font-awesome-icon :icon="['far', 'mail-bulk']" fixed-width /> {{ $t('Webportal.NotificationSettings') }}</b-nav-item>
            <b-nav-item to="/user/locationnotifications" v-if="localUserProfile.Permissions.includes('LocationNotification') && areLocationNotificationsVisible"><font-awesome-icon :icon="['far', 'mail-bulk']" fixed-width /> {{ $t('Webportal.LocationNotifications') }}</b-nav-item>
          </b-nav>
          <div class="tab-content mb-3" id="settings-pane">
            <div class="tab-pane fade show active" role="tabpanel">
              <keep-alive>
                <router-view @unsavedChanges="componentUnsavedChanges" />
              </keep-alive>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthenticationService from '@/services/AuthenticationService';

export default {
  name: "UserSettings",

  methods: {
    componentUnsavedChanges(isFormChanged, callback) {
      if (isFormChanged)
      {
        let dialog = this.$refs.modalUnsavedChanges;

        dialog.$off();
        dialog.$on('ok', _ => callback());
        dialog.$on('cancel', _ => callback(false));
        dialog.show();
      }
      else
        callback();
    }
  },

  computed: {
    localUserProfile: function() {
      return AuthenticationService.localUserProfile;
    },

    areLocationNotificationsVisible: function() {
      return APP_TARGET === 'db';
    }
  }
}
</script>
